module.exports = __webpack_public_path__ + "img/FI17016834.818e3834.png";